import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { RadioButton } from 'primereact/radiobutton';
import { Tree } from 'primereact/tree';
import { Toast } from 'primereact/toast';

import { getPermissionCatalog } from '@actions/profiles'
import { getAllSectionTree } from '@actions/sections'

import { SET_VALUES_PROFILE } from '@constants/actionType'
import { 
  PERMISSION_SECCION,
  PERMISSION_DOCUMENTS,
  SECTION_DOCUMENT_ID,
  SECTION_CONTAINER_DOCUMENT_ID,
  SECTION_HOME_ID
} from '@constants/general'

import { getValueLanguageObj } from '@utils/general'

import store from '@store';

import './style.scss'

class AccesibilityForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissionSelect: [],
      errors: [],
      hasPermissionSecOrDoc: false,
      isPermissionDocument: false,
      navega: 'ALL',
      sectionsSelected: [],
      sectionsTree: [],
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
    };
  }

  async componentDidMount() {
    const { _accessibility } = this.props;
    
    await this.validateAccessibility()
    await this.setSectionsTree()

    if (_accessibility) {
      this.setState({ ..._accessibility });
    }
    this.setState({ loadingPage: false });
  }

  validateAccessibility = async () => {
    const { getPermissionCatalog, permissionCatalog, permissionSelect } = this.props
    let permissionList = []
    if (!permissionCatalog.length) {
      const response = await getPermissionCatalog()
      if (!response?.status) {
        await store.dispatch({
          type: SET_VALUES_PROFILE,
          payload: {
            permissionCatalog: response.data
          }
        });
        permissionList = response.data
      }
    } else {
      permissionList = permissionCatalog
    }
    const {isPermissionSeccionOrDocument, isPermissionDocument} = permissionSelect.reduce((validate, permissionId) => {
      const isOk = permissionList.find(item => item.id === permissionId && (item.seccion === PERMISSION_SECCION || item.seccion === PERMISSION_DOCUMENTS))
      const isOkDoc = permissionList.find(item => item.id === permissionId && (item.seccion === PERMISSION_DOCUMENTS))
      if (isOk) validate.isPermissionSeccionOrDocument = true
      if (isOkDoc) validate.isPermissionDocument = true
      return validate
    }, { isPermissionSeccionOrDocument: false, isPermissionDocument: false })
    this.setState({hasPermissionSecOrDoc: isPermissionSeccionOrDocument, isPermissionDocument})
  }

  setSectionsTree = async () => {
    const { getAllSectionTree } = this.props;
    const response = await getAllSectionTree()
    if (!response.status) {
      const cloneSectionCatalog =  {...response.data}
      const children = this.formattedSectionTree(cloneSectionCatalog.hijos)
      cloneSectionCatalog.children = children
      cloneSectionCatalog.key = cloneSectionCatalog.id
      cloneSectionCatalog.label = getValueLanguageObj(cloneSectionCatalog.nombre)
      // cloneSectionCatalog.selectable = false
      delete cloneSectionCatalog.hijos
      delete cloneSectionCatalog.id_padre

      this.setState({sectionsTree: [cloneSectionCatalog]})

    }

  }

  formattedSectionTree = (data) => data.map(item => {
    item.label = getValueLanguageObj(item.nombre)
    item.key = item.id
    item.children = item.hijos
    item.parentKey = item.id_padre
    delete item.hijos
    delete item.id_padre

    if (item.children) this.formattedSectionTree(item.children)
    return item
  })

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { sectionsSelected, navega, isPermissionDocument , hasPermissionSecOrDoc} = this.state
    const { t } = this.props
    let errors = {}
    if (navega === 'SOME' && hasPermissionSecOrDoc) {
      if (!sectionsSelected.length ) errors = { ...errors, [`sectionsSelected`]: 'sectionsSelected es requerido' }
      else if (isPermissionDocument) {
          const isIncludeSectionDoc = sectionsSelected.includes(SECTION_DOCUMENT_ID) ||
            sectionsSelected.includes(SECTION_CONTAINER_DOCUMENT_ID) ||
            sectionsSelected.includes(SECTION_HOME_ID)
          if (!isIncludeSectionDoc) {
            const hasParentDocumentSection = sectionsSelected.reduce((validate, item) => {
              const parents = this.validateGetParents(item)
              const hasParentDocument = parents.includes(SECTION_DOCUMENT_ID)
              if (hasParentDocument) validate = true
              return validate
            }, false)
            if (!hasParentDocumentSection) {
              this.toast.show({
                severity: 'warn',
                detail: t('Cuentas con un permiso(s) de documentos, por lo que es necesario seleccionar una(s) seccion dentro de documentos'),
                life: 3000,
              });
              errors = { ...errors, [`sectionsSelected`]: 'sectionsSelected es requerido seleccionar seccion documentos' }
            }
          }
        }
    }
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { success } = this.props
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    await this.setValuesToStateGlobal();
    success()
  };

  setValuesToStateGlobal = async () => {
    const { navega, sectionsSelected, hasPermissionSecOrDoc } = this.state;

    await store.dispatch({
      type: SET_VALUES_PROFILE,
      payload: {
        accessibility: {
          navega,
          sectionsSelected,
          hasPermissionSecOrDoc
        }
      }
    });
    return true
  };

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeTree = (e) => {
    const { sectionsSelected } = this.state
    if (!(sectionsSelected.indexOf( e.value) !== -1)) {
      const newSectionSelected = this.validateSectionParent(e.value, sectionsSelected)
      this.setState({sectionsSelected: [ ...newSectionSelected ]})
    }
    this.onHideModal()
  };

  validateSectionParent = (sectionId, sectionsSelected) => {
    const { t } = this.props;
    const getParentsNewSection = this.validateGetParents(sectionId)
    if (getParentsNewSection.length > 1 && sectionsSelected.length) {
      const isChildToSectionSelected = getParentsNewSection.reduce((isChild, item) => {
        const isExist = sectionsSelected.filter(opt => opt === item)
        if (isExist.length) isChild = true
        return isChild
      }, false)
      if (isChildToSectionSelected) {
        // Ya cuenta con alguna seccion padre seleccionada
        this.toast.show({
          severity: 'warn',
          detail: t('Ya cuentas con una seccion padre seleccionada'),
          life: 3000,
        });
        return [...sectionsSelected]
      }
    }

    
    if (sectionsSelected.length) {
      let validateSections = sectionsSelected.reduce((accum, item) => {
        const getParents = this.validateGetParents(item)
        const isNewSectionParent = getParents.includes(sectionId)
        if (!isNewSectionParent) accum.push(item)
        return accum
      }, [])
      return [ ...validateSections, sectionId ]
    }
    return [ ...sectionsSelected, sectionId]
  }
  
  validateGetParents = (sectionId) => {
    const { sectionsTree } = this.state;
    const element = sectionsTree[0];
    const findValue = this.searchTree(element, sectionId);
    const fullParents = this.getParentsSections(findValue, [findValue.id])
    return fullParents
  }

  filterByCategory = () => {
    const { t } = this.props
    const { sectionsTree } = this.state;
    const children = (
      <div className="p-mt-2">
        <Tree
          value={sectionsTree}
          selectionKeys=""
          selectionMode="single"
          onSelectionChange={this.onChangeTree}
          filter
          filterMode="lenient"
        />
      </div>
    );
    this.setState({
      showModal: {
        isVisible: true,
        title: t('Árbol de navegación'),
        textOk: null,
        textHide: t('Cerrar'),
        actionOk: null,
        actionHide: () => this.onHideModal(),
        children,
      },
    });
  };

  onHideModal = () => {
    this.setState({
      showModal: {
        isVisible: false,
        actionHide: () => {},
      },
    });
  };

  searchTree = (element, matchingTitle) => {
    if (element.key === matchingTitle) {
      return element;
    }
    if (element.children != null) {
      let i;
      let result = null;
      for (i = 0; result == null && i < element.children.length; i += 1) {
        result = this.searchTree(element.children[i], matchingTitle);
      }
      return result;
    }
    return null;
  };

  getLabelComplete = (findValue, string) => {
    const { sectionsTree } = this.state;
    let newString = string
    if (findValue.parentKey) {
      const findValueP = this.searchTree(sectionsTree[0], findValue.parentKey);
      if (findValueP.parentKey) newString = `${findValueP.label}  /  ${newString}`
      else newString = `${findValueP.label}  /  ${newString}`
      return this.getLabelComplete(findValueP, newString)
    }
    return newString
  }

  getParentsSections = (findValue, array) => {
    const { sectionsTree } = this.state;
    if (findValue.parentKey) {
      const findValueP = this.searchTree(sectionsTree[0], findValue.parentKey);
      if (findValueP.parentKey) array.unshift(findValueP.id)
      else array.unshift(findValueP.id)
      return this.getParentsSections(findValueP, array)
    }
    return array
  }

  removeSection = (sectionId) => {
    const { sectionsSelected } = this.state
    const removeSection = sectionsSelected.filter(item => item !== sectionId) || []
    this.setState({ sectionsSelected: removeSection })
  }

  render() {
    const { t, btnSubmitLoading, onBack, isEdit  } = this.props;

    const {
      loadingPage,
      errors,
      hasPermissionSecOrDoc,
      navega,
      showModal,
      sectionsSelected,
      sectionsTree
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);

    const footerModal = (
      <div>
        {showModal.actionHide && (
          <Button label={showModal.textHide} onClick={showModal.actionHide} />
        )}
        {showModal.actionOk && (
          <Button label={showModal.textOk} onClick={showModal.actionOk} />
        )}
      </div>
    );

    const renderSectionsSelected = () => sectionsSelected.map(sectionId => {
      const element = sectionsTree[0];
      const findValue = this.searchTree(element, sectionId);
      // console.log('findValue', findValue)
      const fullLabel = this.getLabelComplete(findValue, findValue.label)

      return (
        <div className="p-col-12 p-field p-d-flex p-ai-center section-selected">
          <Button
            icon="pi pi-trash"
            type="button"
            className=" p-button-text p-button-primary p-mr-2"
            onClick={() => this.removeSection(sectionId)}
          />
          {fullLabel}
        </div>
      )
    })

    if (loadingPage) return true;

    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            { hasPermissionSecOrDoc ? (
              <>
                <div className="p-col-12 p-field">
                  <p className="p-text-bold">Debido a que el perfil tiene permisos para Secciones y Documentos, por favor seleccione la opción que corresponda al perfil</p>
                  <div className="p-field-radiobutton">
                    <RadioButton
                      inputId="target1"
                      name="navega"
                      value="ALL"
                      onChange={this.onChange}
                      checked={navega === 'ALL'}
                    />
                    <label>{t('Puede ingresar a todas las secciones')}</label>
                  </div>
                  <div className="p-field-radiobutton">
                    <RadioButton
                      inputId="target1"
                      name="navega"
                      value="SOME"
                      onChange={this.onChange}
                      checked={navega === 'SOME'}
                    />
                    <label>{t('Solo puede ingresar a secciones determinadas')}</label>
                  </div>
                </div>
                { navega === 'SOME' && (
                  <>
                    <div className="p-col-12 p-d-flex p-jc-end">
                      <Button
                        label={t('Agregar sección al perfil')}
                        type="button"
                        className="p-button-info"
                        onClick={() => this.filterByCategory()}
                        style={{width: '220px'}}
                      />
                    </div>
                    { renderSectionsSelected() }
                    { !sectionsSelected.length ? (
                      <div className="p-col-12  not-information">
                          {t('Selecciona al menos una sección al perfil')}
                      </div>
                      ) : ''
                    }
                  </>
                ) }
              </>
              ) : (
              <div className="p-col-12  not-information">
                  {t('Este perfil no tiene permisos para Secciones y Documentos por lo tanto no es necesario definir Accesibilidad')}
              </div>
            )}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <Button
              label={isEdit ? t('Actualizar Perfil') : t('Crear Perfil')}
              type="submit"
              className="p-button-primary"
              loading={btnSubmitLoading}
            />
            </div>
          </div>
        </form>
        <Dialog
          header={showModal.title}
          visible={showModal.isVisible}
          breakpoints={{'960px': '90vw'}}
          style={{ width: '35vw' }}
          footer={footerModal}
          onHide={showModal.actionHide}
        >
          {showModal.children}
        </Dialog>
        <Toast ref={(el) => (this.toast = el)} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissionSelect: state.profile.permissionSelect,
  permissionCatalog: state.profile.permissionCatalog,
  _accessibility: state.profile.accessibility
});

const mapDispatchToProps = {
  getPermissionCatalog,
  getAllSectionTree
};


export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(AccesibilityForm));
